import { ProductSiblingsList } from "models/ProductSiblingsList/productSiblingsList.model";
import { formatDateRange } from "views/CompanySetup/companySetupConstants";

export const transformData = (reports: ProductSiblingsList[]) => {
    return reports?.map((report) => {
        if(!report?.id && report?.reportingPeriod) return; 
      return {
        label: formatDateRange(report.reportingPeriod ?? ''), // You can customize the months if needed
        value: report.id?.toString(),
      };
    });
  };